export default __webpack_public_path__ + "images/cbba92ac990a3b6541c17687fe3395e9.svg";